import React, { Component } from 'react';
import './styles.css';

import Header from './Header';
import Body from './Body';

class PopUpMailLayout extends Component {
	render() {
		return <div className="pop-up-mail-layout">{this.props.children}</div>;
	}
}
Object.assign(PopUpMailLayout, {
	Header,
	Body
});
export default PopUpMailLayout;
